<div class="mb-facet-list"
     data-cy="mb-facet-list"
>
  <div class="inner"
       *ngIf="!(facetsList?.length) && (facetList$ | async)?.facets as facets; else customFacetsListBlock"
       [cxFocus]="isDialog ? dialogFocusConfig : {}"
       (esc)="close($event)"
       (click)="block($event)"
  >

    <mb-facet *ngFor="let facet of facets, index as i"
              #facetRef
              [facet]="facet"
              [cxFocus]="{ lock: true, trap: true, autofocus: 'a' }"
              (unlock)="expandFacetGroup(facet, facetRef)"
              [class.expanded]="isExpanded(facet) | async"
              [class.collapsed]="isCollapsed(facet) | async"
              [attr.data-cy]="'mb-facet-list-item-' + i"
    >
    </mb-facet>
  </div>

  <ng-template #customFacetsListBlock>
    <div class="inner"
         *ngIf="facetsList as facets"
         [cxFocus]="isDialog ? dialogFocusConfig : {}"
         (esc)="close($event)"
         (click)="block($event)"
    >

      <mb-facet *ngFor="let facet of facets, index as i"
                #facetRef
                [facet]="facet"
                [cxFocus]="{ lock: true, trap: true, autofocus: 'a' }"
                (unlock)="expandFacetGroup(facet, facetRef)"
                [class.expanded]="isExpanded(facet) | async"
                [class.collapsed]="isCollapsed(facet) | async"
                [attr.data-cy]="'mb-facet-list-item-' + i"
      >
      </mb-facet>
    </div>
  </ng-template>
</div>

